import React, { useRef } from "react";
import { CustomProperty_TimeInputClass } from "../shared/utils/constants";
import { getThemeMode } from "../shared/utils/helper";

interface Props {
    required?:boolean;
    disabled?:boolean;
    value?:any;
    onChange: (p: any) => void;
}

// Inlined rather than imported: the Northstar icon set has no plain clock
const ClockGlyph = () => (
    <svg viewBox="2 2 16 16" role="presentation" focusable="false" aria-hidden="true">
        <path fill="currentColor" fillRule="evenodd" clipRule="evenodd"
            d="M10 3a7 7 0 1 0 0 14a7 7 0 1 0 0-14Zm0 1.25a5.75 5.75 0 1 1 0 11.5a5.75 5.75 0 1 1 0-11.5Z" />
        <path fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"
            d="M10 6.5V10h3" />
    </svg>
);

export const CustomTimePicker = (prop:Props) => {

    const inputRef = useRef<HTMLInputElement>(null);

    const openPicker = () => {
        const input = inputRef.current;
        if (!input) return;

        input.focus();
        try {
            input.showPicker();
        } catch {
            // no picker available; the field is still typeable
        }
    };

    return (<div className="time-container">
                        <input ref={inputRef} aria-label="Time" type="time"
                            className={`${CustomProperty_TimeInputClass} ${getThemeMode() === "dark" ? "time-input" : ""}`}
                            required={prop.required}
                            disabled={prop.disabled}
                            value={prop.value}
                            onChange={p => {
                                prop.onChange(p);
                            }}/>
                            <button type="button" className="time-icon" tabIndex={-1} aria-hidden="true"
                                disabled={prop.disabled}
                                onClick={openPicker}>
                                <ClockGlyph />
                            </button>
                    </div>);
}
